angular.module('rjmNg.directives').directive "dimensionValuesPicker", [
  "categoryCache"
  (
    categoryCache
  ) ->
    restrict: "E"
    templateUrl: "directive.dimensionValuesPicker.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      dimension: "<"
      index: "<"
      inputValues: "<"
      outputValues: "="
      isVisible: "<"
      changed: "="
      getKeyMetric: "&"
      cohortView: "<"
    controller: [
      () ->
        view = @
        view.loading = false

        view.searchDimensionValue = ""
        view.searchGroupByValueFocus = true

        _updateSelectedValues = () ->
          view.selectedValues = _.keys(view.outputValues[view.index])
          view.changed = not angular.equals(view.inputValues, view.outputValues) or view.selectedValues.length is 0

        _getKeyMetric = () ->
          if view.getKeyMetric?
            return view.getKeyMetric()
          else
            return null

        view.toggleValue = (value, force=false) ->
          if force is true
            view.outputValues[view.index][value] = force
          else
            currentValue = view.outputValues[view.index][value]
            if currentValue is true
              delete view.outputValues[view.index][value]
            else
              view.outputValues[view.index][value] = true
          _updateSelectedValues()

        view.checkIfValueSelected = (value) ->
          return !!view.outputValues[view.index][value]

        view.unselectAllValues = () ->
          view.outputValues[view.index] = {}
          _updateSelectedValues()

        view.updateCategoryCache = () ->
          view.loading = true
          categoryCache.getByDimension(view.dimension, _getKeyMetric(), view.searchDimensionValue)
          .then (responce) ->
            view.loading = false
            view.categoryCache = responce
          .catch (error) ->
            view.loading = false
            view.categoryCache = []

        view.initialization = () ->
          view.outputValues = angular.copy(view.inputValues)
          _updateSelectedValues()

        view.$postLink = () ->
          view.initialization()
          view.updateCategoryCache()

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch('view.inputValues', (newInputValues, oldInputValues) ->
        if not angular.equals(newInputValues, oldInputValues)
          view.initialization()
      , true
      )

      scope.$watch('view.dimension', (newDimension, oldDimension) ->
        if not angular.equals(newDimension, oldDimension)
          view.searchGroupByValueFocus = true
          view.updateCategoryCache()
      , true
      )

      scope.$watch('view.searchDimensionValue', (newSearch, oldSearch) ->
        if newSearch isnt oldSearch
          view.updateCategoryCache()
      , true
      )

      scope.$watch('view.isVisible', (newIsVisible, oldIsVisible) ->
        if newIsVisible isnt oldIsVisible
          if newIsVisible is true
            view.searchGroupByValueFocus = true
          else
            view.initialization()
      )
]
